import { BookletCategory } from "@/@types";
import { BookletCategoryResponse } from "../../booklets/models/BookletCategoryResponse";

export function mapBookletCategory(response: BookletCategoryResponse[]): BookletCategory[] {
    return response.map(category => ({
        name: category.name,
        order: category.order,
        slug: category.slug
    }));
}